<ft-layout-ui [isLoggedIn]="isLoggedIn$ | async"
              [isLoggedOut]="isLoggedOut$ | async"
              [photoUrl]="photoUrl$ | async"
              [isDarkMode]="(isDarkMode$ | async) ?? false"
              (loggedOutChange)="logOut()"
              (darkModeChanged)="toggleDarkMode()">
  <router-outlet></router-outlet>
</ft-layout-ui>
